import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, Image,
	Platform, Dimensions, I18nManager, AsyncStorage } from "react-native";
	
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import MainComponent from "../utilities/MainComponent";
import Stories from 'react-insta-stories';
import AppContext, {AppProvider} from "../utilities/AppContext"

export default class StoryScreen extends MainComponent {	

	static path = 'stories'
	state = {
		store: {},
		title: "Story",
		showFullMode 	: true,
		stories : [],
		data: [],
		index : 0
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
	
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		var images = []

		if(this.context.storyData == undefined){
			this.props.navigation.navigate("menu")
			return
		}

		this.context.storyData.stories.map( obj => {
			obj.images.map(image => {
				images.push(image)
			})
		})

		var mStories = []
			
		this.state.index   = this.context.storyData.index
		this.state.stories = this.context.storyData.stories

		images.map( obj => {
			if(!obj.includes(".mp4"))
			{
				mStories.push({
					content: () => {
					return <div style={{ backgroundColor: 'white', width: "100%"}}>
							<img style={{display: 'block', backgroundColor: "white", maxHeight: '100%', margin: 'auto'}} src={obj}></img>
						</div>
					},
					duration: 4000
				})
			}
			else
			{
				mStories.push({ url: obj, type: 'video'})
			}			
		})

		this.state.data = mStories
		this.setState({data: this.state.data});			
		this.getDetails()
	}

	getDetails = async () => {		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)	
				
            this.setState({store: value})
            
        } catch (error) {
            console.log(error)
        }
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(width){

		return (
			<View style={{flex:1, backgroundColor: 'white', direction: 'ltr'}}>

				<Stories
					style={{backgroundColor : 'white'}}
					isRTL={false}
					currentIndex={this.state.index}
					onAllStoriesEnd={() => { this.props.navigation.goBack(null) }}
					stories={this.state.data}
					defaultInterval={4000}
					width={width}
					height={this.state.height}
				/>										
			
			</View>															
		)
	}

	render() {

		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		var that = this
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

								{that.renderDetails(this.state.width * .33)}

								<View style={styles.topBar}>															
									<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
										<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
									</View>	
									<TouchableOpacity style={{marginTop: 20, height:40, width: 40, justifyContent: "center", alignItems: "center", alignContent: "center"
																		
	
								}}
											onPress={() => { this.props.navigation.goBack(null) }} >																			
											<Image source={require('../assets/close.png')} style={{width: 25, height: 25, overflow:"hidden"}}/>
									</TouchableOpacity>	
									
										
								</View>

							</View>

							<Main {...this.state} changeMenu={this.changeMenu} />

						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && (
						<View style={styles.container}>						
													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
								{that.renderDetails(this.state.width)}
							</View>

							<View style={styles.topBar}>	
								<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
								</View>	
								<TouchableOpacity style={{
										marginTop: 20, height:40, width: 40, justifyContent: "center", alignItems: "center",
										borderRadius: 20,
									}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>													
							</View>
							
						</View>
					)}
				
			</View>
		)}
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "#80000000",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});